import { siteConfig } from "../config/site";

export default function FeaturedSingle() {
  const { featuredSingle, images } = siteConfig;
  return (
    <section
      id="single"
      data-testid="featured-single-section"
      className="relative py-24 sm:py-32"
      style={{
        background:
          "linear-gradient(180deg, transparent 0%, rgba(178,164,255,0.08) 40%, transparent 100%)",
      }}
    >
      <div className="mx-auto max-w-5xl px-6 sm:px-10">
        <div className="text-center">
          <span
            className="inline-block text-[0.7rem] tracking-[0.35em] uppercase text-[color:var(--yicel-violet)] font-semibold"
            data-testid="single-overline"
          >
            {featuredSingle.overline}
          </span>
          <h2
            className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-medium text-ink"
            data-testid="single-title"
          >
            {featuredSingle.title}
          </h2>
          {featuredSingle.description && (
            <p className="mt-5 max-w-xl mx-auto text-base sm:text-lg leading-relaxed text-[color:var(--yicel-muted)]">
              {featuredSingle.description}
            </p>
          )}
        </div>

        <div className="mt-14 grid lg:grid-cols-5 gap-10 items-center">
          <div className="lg:col-span-2 relative">
            <div className="absolute -inset-4 rounded-3xl bg-gradient-to-tr from-[#B9E0FF]/40 to-[#B2A4FF]/40 blur-2xl" />
            <div className="relative aspect-square rounded-3xl overflow-hidden shadow-[0_40px_60px_-25px_rgba(45,42,50,0.4)]">
              <img
                src={images.singleCover}
                alt={featuredSingle.title}
                className="h-full w-full object-cover"
                data-testid="single-cover"
              />
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="glass rounded-3xl p-4 sm:p-5 shadow-[0_20px_60px_-30px_rgba(178,164,255,0.6)]">
              <iframe
                data-testid="single-spotify-embed"
                title={`Spotify player — ${featuredSingle.title}`}
                src={featuredSingle.spotifyEmbed}
                width="100%"
                height="352"
                frameBorder="0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                className="rounded-2xl"
              />
            </div>
            <p className="mt-4 text-center text-xs tracking-[0.2em] uppercase text-[color:var(--yicel-muted)]">
              Dale play · Escucha en tu app favorita
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
